export const CLIENT_ID = 'gstar_eu';

export const CONTAINER_ID = 'stylitics-recommendations-container';
export const TITLE_ID = 'stylitics-widget-title';
export const JUMPLINK_ID = 'stylitics-recommendations-jumplink';
export const JUMPLINK_SEEN_STORAGE_KEY = 'stylitics-jumplink-seen';
export const JUMPLINK_COLLAPSE_DELAY_MS = 2000;

export const SHOP_THE_MODEL_SELECTOR = '.stylitics-bundle-badge';
export const BADGE_MOUNT_ATTRIBUTE = 'data-shop-the-model';
